<template>
	<div>
		<template v-if="$vuetify.breakpoint.smAndUp">
			<v-row class="mt-3 mb-1 mx-3" :justify="$vuetify.breakpoint.width <= 1420 ? 'start':'space-between'">
				<template v-if="$vuetify.breakpoint.width <= 1420">
					<v-row class="ma-0" justify="start">
						<v-menu offset-y :close-on-content-click="true">
							<template v-slot:activator="{ on, attrs }">
								<v-btn class="mr-3 my-2 text-capitalize px-3"
									:color="color"
									v-bind="attrs"
									v-on="on"
									:disabled="!ableEdit"
									@click="is_add_down = !is_add_down"
								>
									<v-icon :color="'#FFFFFF'">mdi-plus</v-icon>
									<span :style="ableEdit ? 'color: #FFFFFF' : 'color: rgba(0, 0, 0, 0.26)'">Add ...</span>
									<v-icon v-if="is_add_down" color="#FFFFFF">mdi-chevron-down</v-icon>
									<v-icon v-if="!is_add_down" color="#FFFFFF">mdi-chevron-up</v-icon>
								</v-btn>
							</template>
							<div style="background-color: white">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white">
										<v-list dense>
											<v-list-item-group
												v-model="add_by"
											>
												<v-list-item
													v-for="add_by in add_by_items"
													:key="add_by.value"
													:color="color"
													@click="is_add_down = !is_add_down; $emit(`${add_by.value}`, 0)"
												>
													{{ add_by.text }}
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</div>
								</div>
							</div>
						</v-menu>
						<div style="width: 240px; height: 36px;" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								v-model="group_by"
								:items="group_by_items"
								:color="color"
								item-color="media"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
								@change="onGroupByChange($event)"
							>
								<template v-slot:selection="{ index, item }">
									<span v-if="index === 0">
										<span class="font-normal-style" style="color: #192A3E">Group by:&nbsp;</span>
										<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
									</span>
								</template>
								<template v-slot:item="{ item }">
									<span class="selector-item-font-style" :class="group_by === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
								</template>
							</v-select>
						</div>
						<div style="width: 240px" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								:class="isStatusDiff ? 'desktop-blue-select' : ''"
								v-model="status_local"
								:items="status_items"
								:color="color"
								:item-color="color"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
								multiple
								return-object
								@change="onStatusChange($event)"
							>
								<template v-slot:selection="{ index }">
									<div v-if="index === 0" style="width: 99%">
										<div class="font-over-long">
											<span class="font-normal-style" style="color: #192A3E">Status:&nbsp;</span>
											<span v-if="status_local.length === 4" class="font-bold-style" style="color: #192A3E">All</span>
											<span v-else class="font-bold-style" style="color: #192A3E">{{ (status_local.map(s => { return s.text })).join() }}</span>
										</div>
									</div>
								</template>
							</v-select>
						</div>
						<div style="width: 240px" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								:class="isDateRangeDiff ? 'desktop-blue-select':''"
								v-model="date_range"
								:items="date_range_items"
								:color="color"
								item-color="media"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
							>
								<template v-slot:selection="{ index, item }">
									<span v-if="index === 0" style="width: 99%">
										<div class="font-over-long">
											<span class="font-normal-style" style="color: #192A3E">Date range:&nbsp;</span>
											<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
										</div>
									</span>
								</template>
								<template v-slot:item="{ item, on }">
									<v-list-item v-on="on" @click="onDateRange(item)" dense>
										<span class="selector-item-font-style" :class="date_range === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
									</v-list-item>
								</template>
							</v-select>
						</div>
						<div style="width: 240px" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								:class="isViewingDiff ? 'desktop-blue-select':''"
								v-model="viewing_local"
								:items="viewing_items"
								:color="color"
								item-color="media"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
								@change="onViewChange($event)"
							>
								<template v-slot:selection="{ index, item }">
									<span v-if="index === 0">
										<div class="font-over-long">
											<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
										</div>
									</span>
								</template>
								<template v-slot:item="{ item }">
									<span class="selector-item-font-style" :class="viewing_local === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
								</template>
							</v-select>
						</div>
						<v-menu
							v-model="search_menu_visible"
							offset-y
							:close-on-content-click="false"
							content-class="media-search-menu"
							key="search-compact-inline"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-tooltip top>
									<template v-slot:activator="{ on: tooltipOn }">
										<v-btn v-bind="attrs" v-on="{ ...on, ...tooltipOn }" class="text-capitalize mr-3 my-2 px-3" :color="'#FAFAFA'" :style="isSearchDiff ? 'border: 1px solid #605AF6':''">
											<v-icon :color="'#82899B'" class="mr-2">mdi-magnify</v-icon>
										</v-btn>
									</template>
									<div>Search</div>
								</v-tooltip>
							</template>
							<div class="media-search-panel pa-3 mt-1">
								<v-text-field
									v-model="search_text"
									:color="color"
									placeholder="Type to search"
									dense
									outlined
									hide-details
									solo
									flat
									@click.stop
									@keydown.enter.stop.prevent="onSearchApply()"
								/>
								<v-row class="ma-0 mt-3" align="center" justify="space-between">
									<v-btn class="text-capitalize media-search-clear" height="32" color="rgba(25, 42, 62, 0.7)" outlined @click.stop="onSearchClear()">CLEAR</v-btn>
									<v-btn class="text-capitalize media-search-submit white--text" height="32" depressed :color="color" @click.stop="onSearchApply()">SEARCH</v-btn>
								</v-row>
							</div>
						</v-menu>
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" v-on="on" class="text-capitalize mr-3 my-2 px-3" :color="'#FAFAFA'" @click="$emit('refresh')">
									<v-icon :color="'#82899B'" class="mr-2">mdi-refresh</v-icon>
								</v-btn>
							</template>
							<div>Refresh</div>
						</v-tooltip>
						<v-menu key="columns-compact-inline" offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on, attrs }">
								<v-tooltip top>
									<template v-slot:activator="{ on: tooltipOn }">
										<v-btn
											:style="isColumnDiff ? 'border: 1px solid #605AF6':''"
											class="text-capitalize mr-3 my-2 px-3"
											color="#FAFAFA"
											v-bind="attrs"
											v-on="{ ...on, ...tooltipOn }"
											@click="is_down = !is_down"
										>
											<ColumnsTable :color="'#82899B'" width="24" height="24" class="mr-2"/>
											<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
											<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
										</v-btn>
									</template>
									<div>Columns</div>
								</v-tooltip>
							</template>
							<div style="height: 68vh; background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white" v-for="item in columns" :key="item.value">
										<v-list-item dense>
											<v-checkbox
												class="mt-0 pt-0"
												v-model="select_columns"
												:label="item.value === 'kind' ? item.text.join(', '):item.text[0]"
												:value="item"
												:color="color"
												dense
												hide-details
											></v-checkbox>
										</v-list-item>
									</div>
								</div>
							</div>
						</v-menu>
						<v-menu key="snapshots-compact-inline" offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on, attrs }">
								<v-tooltip top>
									<template v-slot:activator="{ on: tooltipOn }">
										<v-btn
											v-bind="attrs" 
											v-on="{ ...on, ...tooltipOn }"
											class="mr-3 my-2 text-capitalize px-3" 
											:style="isSnapshortDiff ? 'border: 1px solid #605AF6':''"
											:color="'#FAFAFA'" 
											:disabled="!ableEdit"
										>
											<v-icon :color="'#82899B'">mdi-camera-outline</v-icon>
											<span v-if="$vuetify.breakpoint.width >= 1920" :style="ableEdit ? 'color: #192A3E' :'color: rgba(0, 0, 0, 0.26)'">Snapshots</span>
										</v-btn>
									</template>
									<div>Snapshots</div>
								</v-tooltip>
							</template>
							<div style="background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white">
										<v-list dense>
											<v-list-item-group
												v-model="select_snap"
											>
												<v-list-item
													v-for="snap in snapshots"
													:key="snap.id"
													:color="color"
													@click="$emit('snap', snap.id)"
												>
													{{ snap.desc }}
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</div>
								</div>
							</div>
						</v-menu>
					</v-row>
				</template>
				<template v-else>
					<v-row class="ma-0" justify="start">
						<v-menu offset-y :close-on-content-click="true">
							<template v-slot:activator="{ on, attrs }">
								<v-btn class="mr-3 my-2 text-capitalize px-3"
									:color="color"
									v-bind="attrs"
									v-on="on"
									:disabled="!ableEdit"
									@click="is_add_down = !is_add_down"
								>
									<v-icon :color="'#FFFFFF'">mdi-plus</v-icon>
									<span :style="ableEdit ? 'color: #FFFFFF' : 'color: rgba(0, 0, 0, 0.26)'">Add ...</span>
									<v-icon v-if="is_add_down" color="#FFFFFF">mdi-chevron-down</v-icon>
									<v-icon v-if="!is_add_down" color="#FFFFFF">mdi-chevron-up</v-icon>
								</v-btn>
							</template>
							<div style="background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white">
										<v-list dense>
											<v-list-item-group
												v-model="add_by"
											>
												<v-list-item
													v-for="add_by in add_by_items"
													:key="add_by.value"
													:color="color"
													@click="is_add_down = !is_add_down; $emit(`${add_by.value}`, 0)"
												>
													{{ add_by.text }}
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</div>
								</div>
							</div>
						</v-menu>
						<div style="width: 240px;" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								v-model="group_by"
								:items="group_by_items"
								:color="color"
								item-color="media"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
								@change="onGroupByChange($event)"
							>
								<template v-slot:selection="{ index, item }">
									<span v-if="index === 0">
										<span class="font-normal-style" style="color: #192A3E">Group by:&nbsp;</span>
										<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
									</span>
								</template>
								<template v-slot:item="{ item }">
									<span class="selector-item-font-style" :class="group_by === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
								</template>
							</v-select>
						</div>
						<div style="width: 240px" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								:class="isStatusDiff ? 'desktop-blue-select' : ''"
								v-model="status_local"
								:items="status_items"
								:color="color"
								:item-color="color"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
								multiple
								return-object
								@change="onStatusChange($event)"
							>
								<template v-slot:selection="{ index }">
									<div v-if="index === 0" style="width: 99%">
										<div class="font-over-long">
											<span class="font-normal-style" style="color: #192A3E">Status:&nbsp;</span>
											<span v-if="status_local.length === 4" class="font-bold-style" style="color: #192A3E">All</span>
											<span v-else class="font-bold-style" style="color: #192A3E">{{ (status_local.map(s => { return s.text })).join() }}</span>
										</div>
									</div>
								</template>
							</v-select>
						</div>
						<div style="width: 240px" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								v-model="date_range"
								:items="date_range_items"
								:color="color"
								item-color="media"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
							>
								<template v-slot:selection="{ index, item }">
									<span v-if="index === 0" style="width: 99%">
										<div class="font-over-long">
											<span class="font-normal-style" style="color: #192A3E">Date range:&nbsp;</span>
											<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
										</div>
									</span>
								</template>
								<template v-slot:item="{ item, on }">
									<v-list-item v-on="on" @click="onDateRange(item)" dense>
										<span class="selector-item-font-style" :class="date_range === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
									</v-list-item>
								</template>
							</v-select>
						</div>
						<div style="width: 240px" class="mr-3 my-2">
							<v-select
								class="top-buttons"
								:class="isViewingDiff ? 'desktop-blue-select':''"
								v-model="viewing_local"
								:items="viewing_items"
								:color="color"
								item-color="media"
								:menu-props="{ bottom: true, offsetY: true}"
								background-color="#FAFAFA"
								append-icon="mdi-chevron-down"
								dense
								solo
								hide-details
								@change="onViewChange($event)"
							>
								<template v-slot:selection="{ index, item }">
									<span v-if="index === 0">
										<div class="font-over-long">
											<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
										</div>
									</span>
								</template>
								<template v-slot:item="{ item }">
									<span class="selector-item-font-style" :class="viewing_local === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
								</template>
							</v-select>
						</div>
					</v-row>
					<v-row class="ma-0 media-action-row" justify="end">
						<v-menu
							v-if="$vuetify.breakpoint.width >= 1920"
							key="search-wide-split"
							v-model="search_menu_visible"
							offset-y
							:close-on-content-click="false"
							content-class="media-search-menu"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" v-on="on" class="text-capitalize mr-3 my-2 px-3" :color="'#FAFAFA'" :style="isSearchDiff ? 'border: 1px solid #605AF6':''">
									<v-icon :color="'#82899B'" class="mr-2">mdi-magnify</v-icon>
									<span style="color: #192A3E">Search</span>
								</v-btn>
							</template>
							<div class="media-search-panel pa-3 mt-1">
								<v-text-field
									v-model="search_text"
									:color="color"
									placeholder="Type to search"
									dense
									outlined
									hide-details
									solo
									flat
									@click.stop
									@keydown.enter.stop.prevent="onSearchApply()"
								/>
								<v-row class="ma-0 mt-3" align="center" justify="space-between">
									<v-btn class="text-capitalize media-search-clear" height="32" color="rgba(25, 42, 62, 0.7)" outlined @click.stop="onSearchClear()">CLEAR</v-btn>
									<v-btn class="text-capitalize media-search-submit white--text" height="32" depressed :color="color" @click.stop="onSearchApply()">SEARCH</v-btn>
								</v-row>
							</div>
						</v-menu>
						<v-menu
							v-else
							key="search-compact-split"
							v-model="search_menu_visible"
							offset-y
							:close-on-content-click="false"
							content-class="media-search-menu"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-tooltip bottom>
									<template v-slot:activator="{ on: tooltipOn }">
										<v-btn v-bind="attrs" v-on="{ ...on, ...tooltipOn }" class="text-capitalize mr-3 my-2 px-3" :color="'#FAFAFA'" :style="isSearchDiff ? 'border: 1px solid #605AF6':''">
											<v-icon :color="'#82899B'" class="mr-2">mdi-magnify</v-icon>
										</v-btn>
									</template>
									<div>Search</div>
								</v-tooltip>
							</template>
							<div class="media-search-panel pa-3 mt-1">
								<v-text-field
									v-model="search_text"
									:color="color"
									placeholder="Type to search"
									dense
									outlined
									hide-details
									solo
									flat
									@click.stop
									@keydown.enter.stop.prevent="onSearchApply()"
								/>
								<v-row class="ma-0 mt-3" align="center" justify="space-between">
									<v-btn class="text-capitalize media-search-clear" height="32" color="rgba(25, 42, 62, 0.7)" outlined @click.stop="onSearchClear()">CLEAR</v-btn>
									<v-btn class="text-capitalize media-search-submit white--text" height="32" depressed :color="color" @click.stop="onSearchApply()">SEARCH</v-btn>
								</v-row>
							</div>
						</v-menu>
						<v-btn v-if="$vuetify.breakpoint.width >= 1920" class="text-capitalize mr-3 my-2 px-3" :color="'#FAFAFA'" @click="$emit('refresh')">
							<v-icon :color="'#82899B'" class="mr-2">mdi-refresh</v-icon>
							<span  style="color: #192A3E">Refresh</span>
						</v-btn>
						<v-tooltip v-else bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn v-bind="attrs" v-on="on" class="text-capitalize mr-3 my-2 px-3" :color="'#FAFAFA'" @click="$emit('refresh')">
									<v-icon :color="'#82899B'" class="mr-2">mdi-refresh</v-icon>
								</v-btn>
							</template>
							<div>Refresh</div>
						</v-tooltip>
						<v-menu v-if="$vuetify.breakpoint.width >= 1920" key="columns-wide-split" offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									:style="isColumnDiff ? 'border: 1px solid #605AF6':''"
									class="text-capitalize mr-3 my-2 px-3"
									color="#FAFAFA"
									v-bind="attrs"
									v-on="on"
									@click="is_down = !is_down"
								>
									<ColumnsTable :color="'#82899B'" width="24" height="24" class="mr-2"/>
									<span class="mr-3" style="color: #192A3E">Columns</span>
									<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
									<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
								</v-btn>
							</template>
							<div style="height: 68vh; background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white" v-for="item in columns" :key="item.value">
										<v-list-item dense>
											<v-checkbox
												class="mt-0 pt-0"
												v-model="select_columns"
												:label="item.value === 'kind' ? item.text.join(', '):item.text[0]"
												:value="item"
												:color="color"
												dense
												hide-details
											></v-checkbox>
										</v-list-item>
									</div>
								</div>
							</div>
						</v-menu>
						<v-menu v-else key="columns-compact-split" offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on, attrs }">
								<v-tooltip bottom>
									<template v-slot:activator="{ on: tooltipOn }">
										<v-btn
											:style="isColumnDiff ? 'border: 1px solid #605AF6':''"
											class="text-capitalize mr-3 my-2 px-3"
											color="#FAFAFA"
											v-bind="attrs"
											v-on="{ ...on, ...tooltipOn }"
											@click="is_down = !is_down"
										>
											<ColumnsTable :color="'#82899B'" width="24" height="24" class="mr-2"/>
											<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
											<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
										</v-btn>
									</template>
									<div>Columns</div>
								</v-tooltip>
							</template>
							<div style="height: 68vh; background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white" v-for="item in columns" :key="item.value">
										<v-list-item dense>
											<v-checkbox
												class="mt-0 pt-0"
												v-model="select_columns"
												:label="item.value === 'kind' ? item.text.join(', '):item.text[0]"
												:value="item"
												:color="color"
												dense
												hide-details
											></v-checkbox>
										</v-list-item>
									</div>
								</div>
							</div>
						</v-menu>
						<v-menu v-if="$vuetify.breakpoint.width >= 1920" key="snapshots-wide-split" offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-bind="attrs" 
									v-on="on"
									class="mr-3 my-2 text-capitalize px-3" 
									:style="isSnapshortDiff ? 'border: 1px solid #605AF6':''"
									:color="'#FAFAFA'" 
									:disabled="!ableEdit"
								>
									<v-icon :color="'#82899B'">mdi-plus</v-icon>
									<span :style="ableEdit ? 'color: #192A3E' :'color: rgba(0, 0, 0, 0.26)'">Snapshots</span>
								</v-btn>
							</template>
							<div style="background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white">
										<v-list dense>
											<v-list-item-group
												v-model="select_snap"
											>
												<v-list-item
													v-for="snap in snapshots"
													:key="snap.id"
													:color="color"
													@click="$emit('snap', snap.id)"
												>
													{{ snap.desc }}
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</div>
								</div>
							</div>
						</v-menu>
						<v-menu v-else key="snapshots-compact-split" offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on, attrs }">
								<v-tooltip bottom>
									<template v-slot:activator="{ on: tooltipOn }">
										<v-btn
											v-bind="attrs" 
											v-on="{ ...on, ...tooltipOn }"
											class="mr-3 my-2 text-capitalize px-3" 
											:style="isSnapshortDiff ? 'border: 1px solid #605AF6':''"
											:color="'#FAFAFA'" 
											:disabled="!ableEdit"
										>
											<v-icon :color="'#82899B'">mdi-camera-outline</v-icon>
											<span v-if="$vuetify.breakpoint.width >= 1920" :style="ableEdit ? 'color: #192A3E' :'color: rgba(0, 0, 0, 0.26)'">Snapshots</span>
										</v-btn>
									</template>
									<div>Snapshots</div>
								</v-tooltip>
							</template>
							<div style="background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white">
										<v-list dense>
											<v-list-item-group
												v-model="select_snap"
											>
												<v-list-item
													v-for="snap in snapshots"
													:key="snap.id"
													:color="color"
													@click="$emit('snap', snap.id)"
												>
													{{ snap.desc }}
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</div>
								</div>
							</div>
						</v-menu>
					</v-row>
				</template>
			</v-row>
		</template>
		<template v-if="$vuetify.breakpoint.xsOnly">
			<v-row class="my-3 mx-3">
				<v-col cols="12" class="px-0 py-2">
					<v-row class="ma-0" justify="space-between" align="center">
						<v-menu offset-y :close-on-content-click="true">
							<template v-slot:activator="{ on, attrs }">
								<v-btn class="mr-3 my-2 text-capitalize px-3"
									:color="color"
									v-bind="attrs"
									v-on="on"
									:disabled="!ableEdit"
									@click="is_add_down = !is_add_down"
								>
									<v-icon :color="'#FFFFFF'">mdi-plus</v-icon>
									<span :style="ableEdit ? 'color: #FFFFFF' : 'color: rgba(0, 0, 0, 0.26)'">Add ...</span>
									<v-icon v-if="is_add_down" color="#FFFFFF">mdi-chevron-down</v-icon>
									<v-icon v-if="!is_add_down" color="#FFFFFF">mdi-chevron-up</v-icon>
								</v-btn>
							</template>
							<div style="background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white">
										<v-list dense>
											<v-list-item-group
												v-model="add_by"
											>
												<v-list-item
													v-for="add_by in add_by_items"
													:key="add_by.value"
													:color="color"
													@click="is_add_down = !is_add_down; $emit(`${add_by.value}`, 0)"
												>
													{{ add_by.text }}
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</div>
								</div>
							</div>
						</v-menu>
						<v-menu offset-y :close-on-content-click="false">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									:style="isColumnDiff ? 'border: 1px solid #605AF6':''"
									class="text-capitalize px-2"
									color="#FAFAFA"
									v-bind="attrs"
									v-on="on"
									@click="is_down = !is_down"
								>
									<ColumnsTable :color="'#82899B'" width="24" height="24" class="mr-2"/>
									<span class="mr-3" style="color: #192A3E">Columns</span>
									<v-icon v-if="is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-down</v-icon>
									<v-icon v-if="!is_down" color="rgba(25, 42, 62, 0.7)">mdi-chevron-up</v-icon>
								</v-btn>
							</template>
							<div style="height: 68vh; background-color: white;">
								<div class="tree-wrap">
									<div class="tree-wrap-container" style="background-color: white" v-for="item in columns" :key="item.value">
										<v-list-item dense>
											<v-checkbox
												class="mt-0 pt-0"
												v-model="select_columns"
												:label="item.value === 'kind' ? item.text.join(', '):item.text[0]"
												:value="item"
												:color="color"
												dense
												hide-details
											></v-checkbox>
										</v-list-item>
									</div>
								</div>
							</div>
						</v-menu>
					</v-row>
				</v-col>
				<v-col cols="12" class="px-0 py-2">
					<v-select
						style="height: 36px;"
						v-model="group_by"
						:items="group_by_items"
						:color="color"
						item-color="media"
						:menu-props="{ bottom: true, offsetY: true}"
						background-color="#FAFAFA"
						append-icon="mdi-chevron-down"
						dense
						solo
						hide-details
						@change="onGroupByChange($event)"
					>
						<template v-slot:selection="{ index, item }">
							<span v-if="index === 0">
								<span class="font-normal-style" style="color: #192A3E">Group by:&nbsp;</span>
								<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
							</span>
						</template>
						<template v-slot:item="{ item }">
							<span class="selector-item-font-style" :class="group_by === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
						</template>
					</v-select>
				</v-col>
				<v-col cols="12" class="px-0 py-2">
					<v-select
						:class="isStatusDiff ? 'desktop-blue-select' : ''"
						style="height: 36px;"
						v-model="status_local"
						:items="status_items"
						:color="color"
						:item-color="color"
						:menu-props="{ bottom: true, offsetY: true}"
						background-color="#FAFAFA"
						append-icon="mdi-chevron-down"
						dense
						solo
						hide-details
						multiple
						return-object
						@change="onStatusChange($event)"
					>
						<template v-slot:selection="{ index }">
							<div v-if="index === 0" style="width: 99%">
								<div class="font-over-long">
									<span class="font-normal-style" style="color: #192A3E">Status:&nbsp;</span>
									<span v-if="status_local.length === 4" class="font-bold-style" style="color: #192A3E">All</span>
									<span v-else class="font-bold-style" style="color: #192A3E">{{ (status_local.map(s => { return s.text })).join() }}</span>
								</div>
							</div>
						</template>
					</v-select>
				</v-col>
				<v-col cols="12" class="px-0 py-2">
					<v-select
						:class="isDateRangeDiff ? 'desktop-blue-select':''"
						v-model="date_range"
						:items="date_range_items"
						:color="color"
						item-color="media"
						:menu-props="{ bottom: true, offsetY: true}"
						background-color="#FAFAFA"
						append-icon="mdi-chevron-down"
						dense
						solo
						hide-details
					>
						<template v-slot:selection="{ index, item }">
							<span v-if="index === 0" style="width: 99%">
								<div class="font-over-long">
									<span class="font-normal-style" style="color: #192A3E">Date range:&nbsp;</span>
									<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
								</div>
							</span>
						</template>
						<template v-slot:item="{ item, on }">
							<v-list-item v-on="on" @click="onDateRange(item)" dense>
								<span class="selector-item-font-style" :class="date_range === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
							</v-list-item>
						</template>
					</v-select>
				</v-col>
				<v-col cols="12" class="px-0 py-2">
					<v-select
						style="width: 100%"
						:class="isViewingDiff ? 'desktop-blue-select':''"
						v-model="viewing_local"
						:items="viewing_items"
						:color="color"
						item-color="media"
						:menu-props="{ bottom: true, offsetY: true}"
						background-color="#FAFAFA"
						append-icon="mdi-chevron-down"
						dense
						solo
						hide-details
						@change="onViewChange($event)"
					>
						<template v-slot:selection="{ index, item }">
							<span v-if="index === 0">
								<div class="font-over-long">
									<span class="font-bold-style" style="color: #192A3E">{{ item.text }}</span>
								</div>
							</span>
						</template>
						<template v-slot:item="{ item }">
							<span class="selector-item-font-style" :class="viewing_local === item.value ? 'selector-item-style' : ''">{{ item.text }}</span>
						</template>
					</v-select>
				</v-col>
			</v-row>
		</template>
		<v-dialog v-model="date_range_visible" max-width="600" scrollable>
			<v-alert
				class="mb-0"
				border="top"
				colored-border
				:color="color"
			>
				<v-row class="mx-0 my-1"  align="center">
					<Calendar :color="color" width="20" height="20" class="mr-2"/> 				
					<div class="date-range-picker-title">Select Date range</div>
				</v-row>
				<v-card color="transparent" elevation="0">
					<v-row class="my-3">
						<v-date-picker
							v-model="dates_local"
							:color="color"
							no-title
							scrollable
							range
							next-icon=""
							:max="maxPreMonth"
							:picker-date.sync="pickerPreDate"
							@update:picker-date="onPreMonthChange($event)"
						>
						</v-date-picker>
						<v-date-picker
							v-model="dates_local"
							:color="color"
							no-title
							scrollable
							range
							prev-icon=""
							:min="minNextMonth"
							:picker-date.sync="pickerNextDate"
							@update:picker-date="onNextMonthChange($event)"
						></v-date-picker>
					</v-row>
				</v-card>
				<v-row class="mx-0 my-1" justify="center">
					<v-btn outlined dense class="mr-2 text-capitalize" :color="'rgba(25, 42, 62, 0.7)'" @click="date_range_visible = false">Cancel</v-btn>
					<v-btn :disabled="!dateRangeActive" elevation="0" class="white--text text-capitalize" :color="color" @click="onDateRangApply">Apply date range</v-btn>
				</v-row>
			</v-alert>
		</v-dialog>
	</div>
</template>

<script>
import Calendar from "@/components/icons/calendar.vue";
import ColumnsTable from "@/components/icons/columns_table.vue";
import moment from 'moment';

const Date_Range_Key = 'range';

const Add_By_Items = [
	{ text: 'Add Media', value: 'media' },
	{ text: 'Add Production', value: 'prod' },
	{ text: 'Add 3rd party commission', value: 'tcp' },
	{ text: 'Add Info', value: 'info' }
];

/** Amend media booking */
const MEDED = 'MedEd';

export default {
	name: 'MediaPlanHeader',
	props: {
		color: {
			type: String,
			default: ''
		},
		privileges: {
			type: Array,
			default: () => []
		},
		groupBy: {
			type: String,
			default: ''
		},
		groupByItems: {
			type: Array,
			default: () => []
		},
		status: {
			type: Array,
			default: () => []
		},
		statusItems: {
			type: Array,
			default: () => []
		},
		dateRange: {
			type: String,
			default: ''
		},
		dateRangeItems: {
			type: Array,
			default: () => []
		},
		dates: {
			type: Array,
			default: () => []
		},
		viewing: {
			type: String,
			default: ''
		},
		viewingItems: {
			type: Array,
			default: () => []
		},
		columnHeader: {
			type: Array,
			default: () => []
		},
		isShow: {
			type: Boolean,
			default: true
		},
		snapshots: {
			type: Array,
			default: () => []
		},
		selectSnap: {
			type: Number,
			default: 0
		}
	},
	data() {		
		return {
			date_range_visible: false,
			search_menu_visible: false,
			search_text: '',

			add_by: '',
			add_by_items: Add_By_Items,
			is_add_down: true,

			group_by: this.groupBy,
			group_by_items: this.groupByItems,

			status_local: this.status,
			status_items: this.statusItems,

			date_range: this.dateRange,
			date_range_items: this.dateRangeItems,

			viewing_local: this.viewing,
			viewing_items: this.viewingItems,

			dates_local: this.dates,
			pickerPreDate: moment().format('YYYY-MM'),
			pickerNextDate: moment().add(1, 'M').format('YYYY-MM'),

			is_down: true,
			columns: this.columnHeader,
			select_columns: this.columnHeader.filter(header => { return header.showable === true }),
			select_snap: this.snapshots.findIndex(snap => { return snap.id === this.selectSnap }),
		}
	},
	components: {
		Calendar,
		ColumnsTable,
	},
	computed: {
		maxPreMonth() {
			const date = moment(this.pickerPreDate, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
			return date
		},
		minNextMonth() {
			const date = moment(this.pickerNextDate, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
			return date
		},
		dateRangeActive() {
			let date_range_active = false;

			if (this.dates_local.length === 2) {
				date_range_active = true;
			}

			return date_range_active;
		},
		ableEdit() {
			let is_able = true;

			if (this.privileges.length !== 0) {
				if (!this.privileges.includes(MEDED)) {
					is_able = false;
				}
			}

			return is_able;
		},
		isStatusDiff() {
			let is_diff = false;

			if (this.status_local) {
				const current_selected = this.status_local.map(status => { return status.key });
				current_selected.sort();
				const status_local_str = current_selected.join(',');

				const default_selected_obj = this.status_items.filter(status => { return status.key !== 'reverse'});
				const default_selected = default_selected_obj.map(status => { return status.key });
				default_selected.sort();
				const status_default_str = default_selected.join(',');

				is_diff = status_local_str !== status_default_str ? true : false;
			}

			return is_diff;
		},
		isDateRangeDiff() {
			let is_diff = false;

			if (this.date_range) {
				is_diff = this.date_range !== this.date_range_items[0].value ? true : false;
			}

			return is_diff;
		},
		isViewingDiff() {
			let is_diff = false;

			if (this.viewing_local) {
				is_diff = this.viewing_local !== this.viewing_items[0].value ? true : false;
			}

			return is_diff;
		},
		isSearchDiff() {
			let is_diff = false;

			if (this.search_text && this.search_text.length !== 0) {
				is_diff = true;
			}

			return is_diff;
		},
		isColumnDiff() {
			let is_diff = false;

			if (this.select_columns) {
				is_diff = this.select_columns.length !== this.columns.length ? true : false;
			}

			return is_diff;
		},
		isSnapshortDiff() {
			let is_diff = false;

			if (this.selectSnap > 0) {
				is_diff = true;
			}

			return is_diff;
		}
	},
	watch: {
		columnHeader() {
			this.columns = this.columnHeader;
			this.select_columns = this.columnHeader.filter(header => { return header.showable === true });
		},
		selectSnap() {
			this.select_snap = this.snapshots.findIndex(snap => { return snap.id === this.selectSnap });
		},
		select_columns() {
			const select_columns_keys = this.select_columns.map(s => { return s.value });

			const select_columns_view = [];
			this.columns.forEach(c => {
				if (select_columns_keys.includes(c.value)) {
					c.showable = true;
					select_columns_view.push(c);
				} else {
					c.showable = false;
					select_columns_view.push(c);
				}
			});

			const divider_obj = select_columns_view.findLast(c => { return c.showable === true });
			select_columns_view.forEach(c => {
				if (c.value === divider_obj.value) {
					c.divider = true;
				} else {
					c.divider = false;
				}
			})

			this.$emit('columns', select_columns_view);
		}
	},
	methods: {
		onGroupByChange(group_by) {
			this.$emit('group-by', group_by)
		},
		onStatusChange(status) {
			this.$emit('status', status)
		},
		onDateRange(item) {
			if (item.value === Date_Range_Key) {
				this.date_range_visible = true;
			} else {
				this.$emit('date-range', item.value)
			}
		},
		onDateRangApply() {
			this.date_range_visible = false;
			this.$emit('dates', this.dates_local);
			this.$emit('date-range', Date_Range_Key)
		},
		onPreMonthChange(current_month) {
			this.pickerNextDate = moment(current_month, ['YYYY-MM-DD', 'YYYY-MM']).add(1, 'M').format('YYYY-MM');
		},
		onNextMonthChange(current_month) {
			this.pickerPreDate = moment(current_month, ['YYYY-MM-DD', 'YYYY-MM']).subtract(1, 'M').format('YYYY-MM');
		},
		onViewChange(view) {
			this.$emit('view', view)
		},
		onSearchClear() {
			this.search_text = '';
			this.$emit('clear');
			this.search_menu_visible = false;
		},
		onSearchApply() {
			this.$emit('search', this.search_text);
			this.search_menu_visible = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.font-normal-style {
	font-family: Roboto;
	font-weight: 400;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	vertical-align: middle;
}
.font-bold-style {
	font-family: Roboto;
	font-weight: 500;
	font-size: 14px;
	line-height: 36px;
	letter-spacing: 0.5px;
	vertical-align: middle;
}
.font-over-long {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.selector-item-style {
	color: #605AF6
}
.selector-item-font-style {
	font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1rem;
}
.date-range-picker-title {
	font-family: Roboto;
	font-weight: 700;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: 0.5px;
	color: rgba(96, 90, 246, 1);
}
.media-action-row {
	flex: 0 0 auto;
	min-width: max-content;
}
.media-search-panel {
	background-color: #FFFFFF;
}
.media-search-clear,
.media-search-submit {
	font-size: 14px;
}

::v-deep {
	.top-buttons.v-text-field.v-text-field--solo.v-input--dense > .v-input__control {
		min-height: 36px;
	}
	.top-buttons.v-text-field.v-text-field--solo .v-label {
    top: calc(50% - 12px);
	}
	.desktop-blue-select.v-text-field.v-text-field--solo > .v-input__control > .v-input__slot {
		border: 1px solid #605AF6;
		border-color: #605AF6 !important;
	}
}


</style>
